<div class="header header-fixed header-logo-center">
  <span class="header-title"><%= title %></span>
  <button type="button"
          data-id="btnToggleMenuSidebar"
          data-menu="menu-side"
          class="header-icon header-icon-4" style="color: white"><i class="fas fa-bars"></i></button>
</div>
